import React  from 'react';
import ListOptions from './ListOptions';
import socketIOClient from "socket.io-client";
import {
    withRouter
} from 'react-router-dom';
import axios from 'axios';
import Icon from '@mdi/react'
import { mdiArrowCollapseLeft } from '@mdi/js';
import { mdiArrowExpandRight } from '@mdi/js';
class SideBar extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            list:[

            ],
            activePage:null,
            hidesidebar:false,
        }


        this.parent = null;


        
        
    }


    emojilit = (num) =>{


        var emojis = ["grapes","melon","watermelon","tangerine","lemon","banana","pineapple","mango","apple","green_apple","pear","peach","cherries","strawberry","kiwifruit","tomato","coconut","avocado","eggplant","potato","carrot","corn","hot_pepper","cucumber","leafy_green","broccoli","garlic","onion","mushroom","peanuts","chestnut","bread","croissant","baguette_bread","pretzel","bagel","pancakes","waffle","cheese_wedge","meat_on_bone","poultry_leg","cut_of_meat","bacon","hamburger","fries","pizza","hotdog","sandwich","taco","burrito","stuffed_flatbread","falafel","egg","fried_egg","shallow_pan_of_food","stew","bowl_with_spoon","green_salad","popcorn","butter","salt","canned_food","bento","rice_cracker","rice_ball","rice","curry","ramen","spaghetti","sweet_potato","oden","sushi","fried_shrimp","fish_cake","moon_cake","dango","dumpling","fortune_cookie","takeout_box","crab","lobster","shrimp","squid","oyster","icecream","shaved_ice","ice_cream","doughnut","cookie","birthday","cake","cupcake","pie","chocolate_bar","candy","lollipop","custard","honey_pot","baby_bottle","glass_of_milk","coffee","tea","sake","champagne","wine_glass","cocktail","tropical_drink","beer","beers","clinking_glasses","tumbler_glass","cup_with_straw","beverage_box","mate_drink","ice_cube","chopsticks","knife_fork_plate","fork_and_knife","spoon","hocho","amphora","jack_o_lantern","christmas_tree","fireworks","sparkler","firecracker","sparkles","balloon","tada","confetti_ball","tanabata_tree","bamboo","dolls","flags","wind_chime","rice_scene","red_envelope","ribbon","gift","reminder_ribbon","admission_tickets","ticket","medal","trophy","sports_medal","first_place_medal","second_place_medal","third_place_medal","soccer","baseball","softball","basketball","volleyball","football","rugby_football","tennis","flying_disc","bowling","cricket_bat_and_ball","field_hockey_stick_and_ball","ice_hockey_stick_and_puck","lacrosse","table_tennis_paddle_and_ball","badminton_racquet_and_shuttlecock","boxing_glove","martial_arts_uniform","goal_net","golf","ice_skate","fishing_pole_and_fish","diving_mask","running_shirt_with_sash","ski","sled","curling_stone","dart","yo-yo","kite","8ball","crystal_ball","nazar_amulet","video_game","joystick","slot_machine","game_die","jigsaw","teddy_bear","spades","hearts","diamonds","clubs","chess_pawn","black_joker","mahjong","flower_playing_cards","performing_arts","frame_with_picture","art","thread","yarn","earth_africa","earth_americas","earth_asia","globe_with_meridians","world_map","japan","compass","snow_capped_mountain","mountain","volcano","mount_fuji","camping","beach_with_umbrella","desert","desert_island","national_park","stadium","classical_building","building_construction","bricks","house_buildings","derelict_house_building","house","house_with_garden","office","post_office","european_post_office","hospital","bank","hotel","love_hotel","convenience_store","school","department_store","factory","japanese_castle","european_castle","wedding","tokyo_tower","statue_of_liberty","church","mosque","hindu_temple","synagogue","shinto_shrine","kaaba","fountain","tent","foggy","night_with_stars","cityscape","sunrise_over_mountains","sunrise","city_sunset","city_sunrise","bridge_at_night","hotsprings","carousel_horse","ferris_wheel","roller_coaster","barber","circus_tent","steam_locomotive","railway_car","bullettrain_side","bullettrain_front","train2","metro","light_rail","station","tram","monorail","mountain_railway","train","bus","oncoming_bus","trolleybus","minibus","ambulance","fire_engine","police_car","oncoming_police_car","taxi","oncoming_taxi","car","oncoming_automobile","blue_car","truck","articulated_lorry","tractor","racing_car","racing_motorcycle","motor_scooter","manual_wheelchair","motorized_wheelchair","auto_rickshaw","bike","scooter","skateboard","busstop","motorway","railway_track","oil_drum","fuelpump","rotating_light","traffic_light","vertical_traffic_light","octagonal_sign","construction","anchor","boat","canoe","speedboat","passenger_ship","ferry","motor_boat","ship","airplane","small_airplane","airplane_departure","airplane_arriving","parachute","seat","helicopter","suspension_railway","mountain_cableway","aerial_tramway","satellite","rocket","flying_saucer","bellhop_bell","luggage","hourglass","hourglass_flowing_sand","watch","alarm_clock","stopwatch","timer_clock","mantelpiece_clock","clock12","clock1230","clock1","clock130","clock2","clock230","clock3","clock330","clock4","clock430","clock5","clock530","clock6","clock630","clock7","clock730","clock8","clock830","clock9","clock930","clock10","clock1030","clock11","clock1130","new_moon","waxing_crescent_moon","first_quarter_moon","moon","full_moon","waning_gibbous_moon","last_quarter_moon","waning_crescent_moon","crescent_moon","new_moon_with_face","first_quarter_moon_with_face","last_quarter_moon_with_face","thermometer","sunny","full_moon_with_face","sun_with_face","ringed_planet","star","star2","stars","milky_way","cloud","partly_sunny","thunder_cloud_and_rain","mostly_sunny","barely_sunny","partly_sunny_rain","rain_cloud","snow_cloud","lightning","tornado","fog","wind_blowing_face","cyclone","rainbow","closed_umbrella","umbrella","umbrella_with_rain_drops","umbrella_on_ground","zap","snowflake","snowman","snowman_without_snow","comet","fire","droplet","ocean"]


        return emojis[num];

    }



    componentDidMount = () => {

        this.setState({
            list:this.props.list
        },function(){
            this.setState({
                activePage : this.state.list[0].id
            })
        });
      
    }   


    clickElement = (index) =>{
        var stateCopy = Object.assign({}, this.state);
        stateCopy.pages[index].show = !stateCopy.pages[index].show;
        this.setState(stateCopy);
    }


    changePage = (id) =>{
        this.props.changePageInMain(id);
    }



    show = (props,id) =>{

        const sz = props.length;
        var stateCopy = Object.assign([], props);
        for(var i = 0; i< sz ; i++){
            if(stateCopy[i].id===id){
                stateCopy[i].showicon = true;
               break;
            }else{
                if(stateCopy[i].subpage.length>0){
                    stateCopy[i].subpage = this.show(stateCopy[i].subpage,id);
                }
            }
        }

        return stateCopy;

    }


    searchItem = (props,id) =>{

        const sz = props.length;
        var stateCopy = Object.assign([], props);
        for(var i = 0; i< sz ; i++){
            if(stateCopy[i].id===id){
                stateCopy[i].show = !stateCopy[i].show;
               break;
            }else{
                if(stateCopy[i].subpage.length>0){
                    stateCopy[i].subpage = this.searchItem(stateCopy[i].subpage,id);
                }
            }
        }

        return stateCopy;

    }


    change = (id)=>{

        var stateCopy = this.searchItem(this.state.list,id);

        this.setState({
            list:stateCopy,
        });

     
    }

    hidden = (props,id) =>{

        const sz = props.length;
        var stateCopy = Object.assign([], props);
        for(var i = 0; i< sz ; i++){
            if(stateCopy[i].id===id){
                stateCopy[i].showicon = false;
                stateCopy[i].showoption = false;
               break;
            }else{
                if(stateCopy[i].subpage.length>0){
                    stateCopy[i].subpage = this.hidden(stateCopy[i].subpage,id);
                }
            }
        }

        return stateCopy;

    }

    hideSidebar = () => {

        this.props.hideSidebar();
    }

    ChangePage = (id) =>{

        this.setState({
            activePage : id
        })

        this.props.changePage(id);
    }


    render(){


    
        
        return(
            <div className="sidebar">
                <div className="show-sidebar">
                    <Icon color="#5A687C" onClick={this.hideSidebar} path={(this.props.hidesidebar)===true?mdiArrowExpandRight:mdiArrowCollapseLeft}/>
                </div>
                <div className="list-page">
                    <ListOptions ChangeOption={this.change} active={this.state.activePage} options={this.state.list} ChangePage={this.ChangePage}></ListOptions>
                </div>
               
            </div>
        );
    }


}

export default withRouter(SideBar);